import { UsersListType } from '@okletsplay/core';
import { createSelector } from '@reduxjs/toolkit';
import { EntityStoreName } from 'app/enums/store';
import { AppState } from 'app/interfaces/store';
import { UsersState } from 'modules/users/store/users/interfaces';
import { useMemo } from 'react';

import { entityAdapter } from 'modules/users/store/users/adapter';

const usersState = (state: AppState) => state[EntityStoreName.Users] as UsersState;

const selectAll = entityAdapter.getSelectors<AppState>(
  (state) => state[EntityStoreName.Users] as UsersState
).selectAll;

const selectTotalFactory = (type: UsersListType) =>
  createSelector(usersState, (state) => (type ? state.pagination[type]?.total ?? 0 : 0));

export const usersSelector = {
  all: selectAll,
};

export const usersSelectorFactory = {
  useTotal: (type: UsersListType) => useMemo(() => selectTotalFactory(type), [type]),
};
